import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { cloneDeep } from 'lodash';
import { greateAmericanTypeOfOperationCourier, greateAmericanTypeOfOperationRefrigeratedFreight } from '../../constants/greateAmerican';
import { GREAT_AMERICAN_DECLARATION_P1, getAllQuoteQuestionInfoMap } from '../../localeConstants';
import { getLocalTranslation } from '../../utils/i18nKit';
export var useGreatAmericanDeclation = function useGreatAmericanDeclation() {
  var generateAmericanDeclarationDynamicQuestionInfo = function generateAmericanDeclarationDynamicQuestionInfo(data) {
    var _getLocalTranslation = getLocalTranslation(),
        $t = _getLocalTranslation.$t;

    var _ref = data || {},
        typeOfOperation = _ref.typeOfOperation,
        declarationQuestions = _ref.declarationQuestions;

    var questionInfo = cloneDeep(getAllQuoteQuestionInfoMap()[GREAT_AMERICAN_DECLARATION_P1]);

    if (typeOfOperation === greateAmericanTypeOfOperationRefrigeratedFreight) {
      questionInfo.spec[1].list = [].concat(_toConsumableArray(questionInfo.spec[1].list), [{
        text: $t('pages:declaration.question_text_1')
      }, {
        text: $t('pages:declaration.question_text_2')
      }]);
    } else {
      var _declarationQuestions, _declarationQuestions2;

      var isSpecialCase = typeOfOperation === greateAmericanTypeOfOperationCourier && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions = declarationQuestions['greate_american_use_what_car']) === null || _declarationQuestions === void 0 ? void 0 : _declarationQuestions.truelyValue) === true && (declarationQuestions === null || declarationQuestions === void 0 ? void 0 : (_declarationQuestions2 = declarationQuestions['greate_american_mixed_courier_work']) === null || _declarationQuestions2 === void 0 ? void 0 : _declarationQuestions2.truelyValue) === false;

      if (isSpecialCase) {
        questionInfo.spec[1].list.splice(0, 1);
      }
    }

    return questionInfo;
  };

  return {
    generateAmericanDeclarationDynamicQuestionInfo: generateAmericanDeclarationDynamicQuestionInfo
  };
};